import React from 'react';

export default function LoadingScreen() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      height: '100vh', gap: 16, background: 'var(--app-bg)',
    }}>
      <div className="spinner" />
      <p style={{ color: 'var(--ink-3)', fontSize: 13, fontFamily: 'var(--font-ui)' }}>
        Loading Dagrun PM…
      </p>
    </div>
  );
}
